import {
  buildAddedAncillaryItem,
  buildDateTimeLabel,
  buildGuestsCountLine,
  buildOptionsLine,
  filterAncillaryItems,
  formatAncillaryTitle,
  getAncillaryProductName,
  IAddedAncillaryItem,
  IPotentialBookingAncillaryItem,
} from './addedAncillaryShared';

export interface IAddedAncillaryGroundService extends IAddedAncillaryItem {
  baseProductName?: string;
  variantName?: string;
  time?: string;
  airportName?: string;
  cancellationPolicy?: string | null;
}

export interface IPotentialBookingGroundService extends IPotentialBookingAncillaryItem {}

export const buildAddedAncillaryGroundService = (
  groundService: IPotentialBookingGroundService
): IAddedAncillaryGroundService => {
  const userSelections = groundService.ancillaryData?.userSelections;
  const ancillaryProduct = groundService.ancillaryData?.product;

  return {
    ...buildAddedAncillaryItem(
      groundService,
      'added-ancillary-ground-service',
      groundService.product?.name ?? groundService.title
    ),
    baseProductName: ancillaryProduct?.baseProductName,
    variantName: ancillaryProduct?.variantName ?? undefined,
    time: userSelections?.time,
    airportName: userSelections?.airportName,
    cancellationPolicy: groundService.cancellationPolicy,
  };
};

export const filterAncillaryGroundServices = (groundServices: unknown[]): IPotentialBookingGroundService[] =>
  filterAncillaryItems(groundServices);

export const buildAddedAncillaryGroundServices = (groundServices: unknown[]): IAddedAncillaryGroundService[] =>
  filterAncillaryGroundServices(groundServices).map(buildAddedAncillaryGroundService);

export const buildGroundServiceGuestsLine = (groundService: IAddedAncillaryGroundService): string =>
  buildGuestsCountLine(groundService.numberOfAdults, groundService.numberOfChildren);

export const getAncillaryGroundServiceProductName = (groundService: IAddedAncillaryGroundService): string =>
  getAncillaryProductName(groundService);

export const formatAncillaryGroundServiceTitle = (groundService: IAddedAncillaryGroundService): string =>
  formatAncillaryTitle(groundService);

export const buildGroundServiceDateLine = (groundService: IAddedAncillaryGroundService): string =>
  [buildDateTimeLabel({ date: groundService.date, time: groundService.time }), groundService.airportName]
    .filter(Boolean)
    .join(', ');

export const buildAncillaryGroundServiceDetailLines = (groundService: IAddedAncillaryGroundService): string[] => {
  const hasGuests = groundService.numberOfAdults > 0 || groundService.numberOfChildren > 0;

  return [
    hasGuests ? `${buildGroundServiceGuestsLine(groundService)}.` : '',
    buildGroundServiceDateLine(groundService),
    buildOptionsLine(groundService.options),
  ].filter(line => line !== '');
};
